import React, { useEffect, useState } from "react";
import "./css/footer.css";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../api";



export default function Footer() {
  const [showImprint, setShowImprint] = useState(true);

  useEffect(() => {
    async function loadLegal() {
      try {
        const response = await fetch(`${API_BASE_URL}/api/legal`);
        const data = await response.json();
        setShowImprint(data.pages?.imprint?.visible !== false);
      } catch (error) {
        console.error("Fehler beim Abrufen der Impressum-Sichtbarkeit:", error);
      }
    }

    loadLegal();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-left">
          {showImprint && <Link to="/impressum">Impressum</Link>}
        </div>

        <div className="footer-center">
          © {new Date().getFullYear()} James-Schreiber.de
        </div>

        <div className="footer-right">
          <Link to="/datenschutz">
            Datenschutz
          </Link>
        </div>

      </div>
    </footer>
  );
}
